<template>
  <div class="container">
    <div class="newsletter-box">
      <h1>Subscribe to Our Newsletter</h1>
      <p>Stay updated with our latest news and updates</p>
      
      <div v-if="!submitted" class="form-container">
        <input 
          type="email" 
          v-model="email" 
          placeholder="Enter your email address"
          :class="{ 'error': emailError }"
          @input="emailError = ''"
        >
        <button @click="submitEmail" :disabled="isLoading">
          {{ isLoading ? 'Submitting...' : 'Subscribe' }}
        </button>
        <p v-if="emailError" class="error-message">{{ emailError }}</p>
      </div>
      
      <div v-else class="success-message">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        <h2>Thank You!</h2>
        <p>Your subscription has been confirmed.</p>
        <p>You've been added to our mailing list and will hear from us soon.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '../../firebase'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'

export default {
  name: 'HomePage',
  data() {
    return {
      email: '',
      submitted: false,
      emailError: '',
      isLoading: false
    }
  },
  methods: {
    async submitEmail() {
      if (!this.validateEmail(this.email)) {
        this.emailError = 'Please enter a valid email address';
        return;
      }
      
      this.isLoading = true;
      
      try {
        const emailData = {
          value: this.email,
          createdAt: serverTimestamp()
        }
        
        await addDoc(collection(db, 'emails'), emailData);
        
        this.isLoading = false;
        this.submitted = true;
        console.log('Email submitted:', this.email);
      } catch (error) {
        console.error('Error saving email:', error);
        this.emailError = 'Failed to subscribe. Please try again.';
        this.isLoading = false;
      }
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.newsletter-box {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 500px;
  text-align: center;
}

h1 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #111827;
}

p {
  color: #6b7280;
  margin-bottom: 24px;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

input {
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  width: 100%;
  transition: border-color 0.2s;
}

input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

input.error {
  border-color: #ef4444;
}

button {
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

button:hover {
  background-color: #2563eb;
}

button:disabled {
  background-color: #93c5fd;
  cursor: not-allowed;
}

.error-message {
  color: #ef4444;
  font-size: 14px;
  margin-top: -8px;
  text-align: left;
}

.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #10b981;
}

.success-message svg {
  margin-bottom: 16px;
}

.success-message h2 {
  color: #10b981;
  margin-bottom: 16px;
}

@media (max-width: 640px) {
  .newsletter-box {
    padding: 24px;
  }
  
  h1 {
    font-size: 20px;
  }
}
</style>
